import type { Sorting } from '#~/device/discovery/components/selector/index.js';
import { DefaultSorting, toSorting } from '#~/device/discovery/components/selector/index.js';
import type { UsePrefState } from '#~/preferences/hooks.js';
import { usePrefState } from '#~/preferences/hooks.js';
import { usePopupStore } from '#~/store/popup.js';
import { toJson } from '@tryiris-ai/js-types';
import { useAddSourceAuthStore } from './dialogs/credentials-dialog.store.js';
import { Filter } from './types.js';
import { toFilter } from './utils.js';

/**
 * Video device filter.
 *
 * @returns Active filter.
 */
export const useFilterPref = (): UsePrefState<Filter> =>
  usePrefState('video.add.filter', Filter.All, {
    deserialize: toFilter
  });

/**
 * Video device sorting.
 *
 * @returns Device sorting.
 */
export const useSortingPref = (): UsePrefState<Sorting> =>
  usePrefState('video.add.sorting', DefaultSorting, {
    deserialize: toSorting,
    serialize: toJson
  });

/**
 * Hook that returns a function to imperatively start the 'add video source auth' workflow.
 *
 * @returns Imperative function.
 */
export const useAddSourceAuth = (): (() => void) => {
  const { setShow } = useAddSourceAuthStore();
  const { hidePopup } = usePopupStore();

  return () => {
    hidePopup();
    setShow(true);
  };
};
